export default "__VITE_ASSET__Dh4yVht0__"